/**
 * Hover Context for Value Flows Canvas
 *
 * Provides hover state management for ReactFlow nodes and edges.
 * Uses ReactFlow's onNodeMouseEnter/Leave callbacks which are more reliable
 * than handlers on custom node wrappers.
 */
import { createContext, useContext } from "react";

interface HoverContextValue {
  /** ID of currently hovered node, or null */
  hoveredNodeId: string | null;
  /** ID of currently hovered edge, or null */
  hoveredEdgeId: string | null;
}

const HoverContext = createContext<HoverContextValue>({
  hoveredNodeId: null,
  hoveredEdgeId: null,
});

export const HoverProvider = HoverContext.Provider;

export function useHoverContext() {
  return useContext(HoverContext);
}
